const seoProps = {
  title: "Page not found",
  meta: [
    {
      name: "description",
      content: "this page doesn't exits",
    },
    {
      name: "robots",
      content: "noindex, nofollow, noodp, noydir",
    },
  ],
};

export default seoProps;
